import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import { LoadingButton } from './LoadingSkeleton';

const CopyDayModal = ({
  show,
  onHide,
  onConfirm,
  sourceDay,
  recipeCount,
  isCopying = false,
  currentPlanType = 'current'
}) => {
  const [targetDay, setTargetDay] = useState(null);
  const [replaceBehavior, setReplaceBehavior] = useState('merge'); // 'merge' or 'replace'
  
  const dayOptions = [
    { value: "Sunday", label: "Sunday" },
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
    { value: "None", label: "None" }
  ].filter(day => day.value !== sourceDay);
  
  const selectStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '38px',
    }),
  };
  
  const handleConfirm = () => {
    if (targetDay) {
      onConfirm(sourceDay, targetDay.value, replaceBehavior);
    }
  };
  
  const handleHide = () => {
    setTargetDay(null);
    setReplaceBehavior('merge');
    onHide();
  };

  return (
    <Modal 
      show={show} 
      onHide={handleHide} 
      centered
      backdrop="static"
      keyboard={!isCopying}
    >
      <Modal.Header closeButton={!isCopying}>
        <Modal.Title>
          <i className="fas fa-copy me-2"></i>
          Copy Day's Plan
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Copy <strong>{recipeCount} recipes</strong> from <strong>{sourceDay}</strong> to another day.
        </p>
        
        <Form.Group className="mb-3">
          <Form.Label>Select destination day:</Form.Label>
          <Select
            value={targetDay}
            onChange={setTargetDay}
            options={dayOptions}
            placeholder="Choose a day..."
            isClearable={false}
            isSearchable={false}
            isDisabled={isCopying}
            styles={selectStyles}
          />
        </Form.Group>
        
        <Form.Group>
          <Form.Label>If the destination day has recipes:</Form.Label>
          <Form.Check
            type="radio"
            id="merge-recipes"
            label="Add to existing recipes (merge)"
            checked={replaceBehavior === 'merge'}
            onChange={() => setReplaceBehavior('merge')}
            disabled={isCopying}
          />
          <Form.Check
            type="radio"
            id="replace-recipes"
            label="Replace all existing recipes"
            checked={replaceBehavior === 'replace'}
            onChange={() => setReplaceBehavior('replace')}
            disabled={isCopying}
          />
        </Form.Group>
        
        {replaceBehavior === 'replace' && (
          <div className="alert alert-warning mt-3 mb-0">
            <i className="fas fa-exclamation-triangle me-2"></i>
            <strong>Warning:</strong> This will delete all existing recipes from {targetDay?.label || 'the selected day'} before copying.
          </div>
        )}
        
        {currentPlanType === 'current' && (
          <div className="alert alert-info mt-3 mb-0">
            <i className="fas fa-info-circle me-2"></i>
            <small>Copied recipes will be added to your shopping list.</small>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={handleHide}
          disabled={isCopying}
        >
          Cancel
        </Button>
        <LoadingButton
          variant="primary"
          onClick={handleConfirm}
          disabled={!targetDay}
          isLoading={isCopying}
          loadingText="Copying..."
        >
          <i className="fas fa-copy me-1"></i>
          Copy Recipes
        </LoadingButton>
      </Modal.Footer>
    </Modal>
  );
};

export default CopyDayModal;